const hasVaillantHostname = ['vaillant-germany-spa-demo.dsp.vaillant-group.com', 'vaillant.localhost'].includes(window.location.hostname);
const isLocalVaillant = window.location.hostname === 'localhost' && process.env?.REACT_APP_REALM === 'vaillant'
export const isVaillant = hasVaillantHostname || isLocalVaillant;
